/**
 * @description 受益人類型 (enum)
 */
export enum TargetBeneficiaryTypesEnum {
  /** 法定繼承人 */
  LegalHeir = 'L',
  /** 指定受益人 */
  Designated = 'D'
}
